// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, recordOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdChartsUninstallResult = objectOf({
  any_apps_without_uninstall_tracking: boolean,
  all_apps_without_uninstall_tracking: boolean,
  daily_uninstall_stats: arrayOf(arrayOf(number)),
  daily_uninstall_stats_by_segment: recordOf({
    key: string,
    value: arrayOf(arrayOf(number)),
  }),
});
